/**
 * custom.js -- Add any custom JavaScript code here, export as modules.
 */

document.addEventListener("ooo-wishlist:product-added", (event) => {
  // TODO add a custom pixel
  console.log("event", event.detail);
});
